import * as React from "react";
import "./styles.scss";
import Carousel from "react-simply-carousel";

const RewardsCarousel = ({ rewardsList }) => {
    const [activeSlideIndex, setActiveSlideIndex] = React.useState(null);
    return (
        <Carousel
            containerProps={{
                style: {
                    width: "100%",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    marginTop: '30px',
                    marginBottom: '30px'
                }
            }}
            activeSlideIndex={activeSlideIndex}
            activeSlideProps={{
                style: {
                    overflow: "hidden"
                }
            }}
            onRequestChange={setActiveSlideIndex}
            forwardBtnProps={{
                show: false
            }}
            backwardBtnProps={{
                show: false
            }}
            dotsNav={{
                show: true,
                containerProps: {
                    style: {
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '8px',
                        margin: '25px auto 10px'
                    },
                },
                itemBtnProps: {
                    style: {
                        height: 10,
                        width: 10,
                        borderRadius: "50%",
                        border: 0,
                        background: '#d9d9d9',
                        padding: 0
                    }
                },
                activeItemBtnProps: {
                    style: {
                        height: 10,
                        width: 25,
                        borderRadius: "20px",
                        border: 0,
                        background: "#5ECDBF"
                    }
                }
            }}
            itemsToShow={1}
            itemsToScroll={1}
            speed={400}
            infinite={false}
        >
            {rewardsList?.map((item, index) => (
                <div key={index} className="reward-carousel">
                    <img src={item.image || item.reward_image_url} alt="" />
                    <div className="title">
                        <p>{item.title || item.reward_title}</p>
                    </div>
                </div>
            ))}
        </Carousel>
    );
};

export default RewardsCarousel;
